import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import { environmentVariables } from "../../config/env.config";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { userContext } from "../../context/userContext";
import axios from "axios";
import "./CustomPaymentHistoryStyle.css";

const KYCList = () => {
  const baseUrl = environmentVariables?.apiUrl;
  const { t } = useTranslation();
  const { userData } = useContext(userContext);

  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const abortController = new AbortController();

  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    noRowsPerPage: false,
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };
  const customStyles = {
    headRow: {
      style: {
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
        textAlign: "left",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px", // Same font size as regular cells
        minHeight: "52px",
        padding: "8px 10px", // Same padding as regular cells
        textAlign: "left",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px", // Ensure similar padding here
        fontSize: "13px", // Match font size with header
        // textTransform: "capitalize",
        minHeight: "48px !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    cells: {
      style: {
        // minWidth: "50px !important",
        padding: "0px 5px", // Same padding as header cells
        fontSize: "13px", // Match font size with header
        textAlign: "left", // Ensure same text alignment as header
      },
    },
  };

// ?countryCode=${activeCountry}&fromDate=${selectedDateFrom}&toDate=${selectedDateTo}&nameOrderId=${nameOrderId}
  async function fetchData(page, size = perPage) {
    try {
      const response = await axios.get(
        `${baseUrl}api/v1/kyc/get_all_kyc_data?page=${page}&limit=${size}`,
        {
          headers: {
            _token: userData?.token,
          },
          signal: abortController.signal,
        }
      );
      console.log("response", response?.data);
      if (response.status === 200) {
        const { data, countries } = response?.data;
        const { totalRecords, currentPage } = response?.data?.pagination;
        setResponseData(data);
        // setCountryData(countries);        
        setTotalRows(totalRecords || 0);
        setCurrentPage(currentPage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setResponseData([]);
    }
  }
  useEffect(
    () => {
      fetchData(1);
      return () => {
        abortController.abort();
      };
    },
    [
        // isLoading
      // activeCountry,
      // selectedDateFrom,
      // selectedDateTo,
      // nameOrderId,
      // currentPage,
      // perPage
    ]
  );

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }
  const windowWidth = useWindowWidth();
  const columns = [
    {
      name: "Full Name",
      sortable: true,
      cell: (row) => (
        <div
        //   className="custom-cell order-id-cell custom-cell-bold"
          data-column-name="Order_id"
        >
          {row?.person?.firstName || "--"}
        </div>
      ),
      width: windowWidth > 768 ? "300px" : "100%",
    },
     {
      name: "Document Type",
      cell: (row) => (
        <div
          className="custom-cell custom-cell-bold"
          data-column-name="Opening Balance"
        >
          {row?.document?.type || "--"}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "ID",
      cell: (row) => (
        <div
          className="custom-cell custom-cell-bold"
          data-column-name="Opening Balance"
        >
          {row?.document?.number ? 'X'.repeat(row?.document?.number?.length - 4) + row?.document?.number?.slice(-4) : "--"}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Status",
      cell: (row) => (
        <div
          className="custom-cell custom-cell-bold"
          data-column-name="Closing Balance"
        >
          {/* {row?.verifyStatus == "approved" ? <div style={{color:"green"}}>{row?.verifyStatus}</div> : <div style={{color:"red"}}>{row?.verifyStatus}</div> || "--"}{" "} */}
        {row?.verifyStatus ? (
          <div style={{ color: row?.verifyStatus === "approved" ? "green" : "red", textTransform: "capitalize" }}>
            {row?.verifyStatus}
          </div>
        ) : (
          "--"
        )}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Reason",
      cell: (row) => (
        <div
          className="custom-cell custom-cell-bold"
          data-column-name="Closing Balance"
        >
          {row?.reason || "--"}{" "}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
  
  ];

  const tableData = {
    columns,
    data: responseData,
  };

  const tableExtensions = {
    export: false,
    print: false,
  };
  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchData(page, newPerPage);
  };
  return (
    <div className="main">
      {isLoading ? (
        <CircularLoader size={40} />
      ) : (
        <>
          <DataTableExtensions
            {...tableExtensions}
            {...tableData}
            customStyles={customStyles}
            filterPlaceholder="Search User By name"
          >
            <DataTable
              columns={columns}
              data={responseData}
              noHeader
              defaultSortField="id"
              sortIcon={<SortIcon />}
              defaultSortAsc={true}
              pagination
              paginationServer
              paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              highlightOnHover
              dense
              // paginationPerPage={perPage}
              paginationComponentOptions={{
                ...paginationOptions,
              }}
              progressPending={isLoading}
              customStyles={customStyles}
              noDataComponent={
                <div style={{ padding: "24px" }}>{t("No_records_found")}</div>
              }
            />
          </DataTableExtensions>
        </>
      )}
    </div>
  );
};

export default KYCList;
